import { AuthActionTypes } from './auth.types';

export const setCurrentUser = user => ({
  type: AuthActionTypes.SET_CURRENT_USER,
  payload: user
});

export const setAuthHeader = token => ({
  type: AuthActionTypes.SET_TOKEN,
  payload: token
});

export const setPriviledge = priviledge => ({
  type: AuthActionTypes.SET_PRIVILEGE,
  payload: priviledge
});

export const setPageBeforeLogin = path => ({
  type: AuthActionTypes.SET_PAGE_BEFORE_LOGIN,
  payload: path
});

export const setLogoutState = state => ({
  type: AuthActionTypes.SET_LOGOUT_STATE,
  payload: state
});